module.exports = __webpack_public_path__ + "img/Icon_LockOpen_ActiveGreen.99c59045.svg";